import { provideZoneChangeDetection } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import * as Sentry from '@sentry/angular';
import { environment } from '@dgacontrol-frontend/environments';

Sentry.init({
  dsn: environment.sentry.admin,
  // Same as the deprecated `sendDefaultPii: true` (Sentry's defaultPiiToCollectionOptions):
  // user info such as the IP address, and 7 context lines instead of the default 5.
  dataCollection: { userInfo: true, frameContextLines: 7 },
});
bootstrapApplication(AppComponent, {
  ...appConfig,
  providers: [provideZoneChangeDetection(), ...appConfig.providers],
}).catch((err: unknown) => {
  console.error(err);
});
